import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("token");
    const isLoginPage = location.pathname === "/login";
    const isRootPage = location.pathname === "/";

    if (isRootPage) {
      navigate(isAuthenticated ? "/dashboard" : "/login");
    } else if (!isAuthenticated && !isLoginPage) {
      navigate("/login");
    } else if (isAuthenticated && isLoginPage) {
      navigate("/dashboard");
    }
  }, [location.pathname]);

  return <Outlet />;
}

export default App;
